import { render, staticRenderFns } from "./ModuleCategoryDropdown.vue?vue&type=template&id=76404098&"
import script from "./ModuleCategoryDropdown.vue?vue&type=script&lang=js&"
export * from "./ModuleCategoryDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports